document.addEventListener("DOMContentLoaded", () => {

  /*
  =========================
  TABS
  =========================
  */
  document.querySelectorAll(".custom-bundle__tab").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const tabId = button.dataset.tab;
      const wrapper = button.closest(".custom-bundle__items");

      wrapper.querySelectorAll(".custom-bundle__tab").forEach((tab) => {
        tab.classList.remove("custom-bundle__tab--active");
      });

      wrapper.querySelectorAll(".custom-bundle__tab-content").forEach((content) => {
        content.classList.remove("is-active");
      });

      button.classList.add("custom-bundle__tab--active");

      const activeContent = wrapper.querySelector(
        `.custom-bundle__tab-content[data-content="${tabId}"]`
      );

      if (activeContent) {
        activeContent.classList.add("is-active");
      }

      const selectedOption = activeContent.querySelector(".custom-bundle__option--selected");

      if (selectedOption) {
        updateOptionUI(selectedOption);
      } else {
        const descriptionBox = document.getElementById("custom-bundle-description");
        if (descriptionBox) descriptionBox.style.display = "none";
      }
    });
  });

  function updateDescription(option) {
    const itemsWrapper = option.closest(".custom-bundle__items");

    //if (!itemsWrapper || itemsWrapper.dataset.swatchType !== "Color") return;

    const descriptionBox = document.getElementById("custom-bundle-description");
    if (!descriptionBox) return;

    const descriptionTitle = descriptionBox.querySelector(".custom-bundle__description-title");
    const descriptionText = descriptionBox.querySelector(".custom-bundle__description-text");

    const description = option.dataset.variantDescription || "";

    if (description.trim() === "") {
      descriptionBox.style.display = "none";
      descriptionBox.style.borderColor = "transparent";
      descriptionTitle.textContent = "";
      descriptionText.textContent = "";
      return;
    }

    descriptionBox.style.display = "block";
    descriptionBox.style.borderColor = option.dataset.variantColor || "";
    descriptionTitle.textContent = option.dataset.variantTitle || "";
    descriptionText.textContent = description;
  }

  function updateBundleImage() {
    const gallery = document.querySelector(
      "media-carousel.product-gallery__media-list"
    );

    const comboSlide = gallery?.querySelector(".bundle-combo-slide");
    const img = comboSlide?.querySelector("img");

    if (!gallery || !comboSlide || !img) return;

    const baseItemsGroup = document.querySelector(
      '.custom-bundle__items[data-item-type="Base Unit"]'
    );

    const replacementItemsGroup = document.querySelector(
      '.custom-bundle__items[data-item-type="Replacement"]'
    );

    const selectedBase = baseItemsGroup?.querySelector(
      ".custom-bundle__option--selected"
    );

    const selectedReplacement = replacementItemsGroup?.querySelector(
      ".custom-bundle__option--selected"
    );

    let imageSrc = "";

    // Base only
    if (selectedBase) {
      imageSrc = selectedBase.dataset.variantImageSrc || "";
    }

    // Replacement selected
    if (selectedReplacement) {
      // Try combo image only if a Base Unit is selected
      if (selectedBase && selectedReplacement.dataset.variantImages) {
        const baseOptions = [
          ...baseItemsGroup.querySelectorAll(".custom-bundle__option")
        ];

        const baseIndex = baseOptions.indexOf(selectedBase);

        const images = selectedReplacement.dataset.variantImages
          .split(",")
          .map((img) => img.trim());

        if (images[baseIndex]) {
          imageSrc = images[baseIndex];
        } else {
          imageSrc = selectedReplacement.dataset.variantImageSrc || imageSrc;
        }
      } else {
        // Replacement-only bundle
        imageSrc = selectedReplacement.dataset.variantImageSrc || imageSrc;
      }
    }

    if (!imageSrc) {
      comboSlide.classList.add("hide");

      document.querySelectorAll(".bundle-combo-dot").forEach((dot) => {
        dot.hidden = true;
      });

      return;
    }

    img.src = imageSrc;

    comboSlide.classList.remove("hide");

    document.querySelectorAll(".bundle-combo-dot").forEach((dot) => {
      dot.hidden = false;
    });

    // Combo slide is the second slide
    gallery.select(1);
  }

  function clearDescription() {
    const descriptionEl = document.querySelector(
      "#custom-bundle-description"
    );

    if (!descriptionEl) return;

    const titleEl = descriptionEl.querySelector(
      ".custom-bundle__description-title"
    );

    const textEl = descriptionEl.querySelector(
      ".custom-bundle__description-text"
    );

    if (titleEl) titleEl.textContent = "";
    if (textEl) textEl.textContent = "";

    descriptionEl.style.borderColor = "";
    descriptionEl.classList.remove("active");
  }

  function updateOptionUI(option) {
    const itemsWrapper = option.closest(".custom-bundle__items");

    if (!itemsWrapper) return;

    /*
    =========================
    IMAGE
    =========================
    */
    if (itemsWrapper.dataset.swatchType === "Variant Image") {
      updateBundleImage(option);
    }

    /*
    =========================
    DESCRIPTION
    =========================
    */
    const description = option.dataset.variantDescription?.trim();

    if (description) {
      updateDescription(option);
    } else {
      //clearDescription();
    }
  }

  function formatMoney(cents) {
    return `$${(cents / 100).toLocaleString(
      document.documentElement.lang || "en",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    )}`;
  }

  function updateBundlePrice() {
    let total = 0;

    document.querySelectorAll(".custom-bundle__option").forEach((option) => {

      const qty = parseInt(
        option.querySelector(".custom-bundle__qty-value")?.value || 0
      );

      const price = parseInt(option.dataset.variantPrice || 0);

      if (!isNaN(price) && qty > 0) {
        total += price * qty;
      }
    });

    /*
    =========================
    ONE TIME PRICE
    =========================
    */
    document.querySelectorAll(".one-time-price").forEach((el) => {
      el.innerHTML = total > 0 ? formatMoney(total) : "";
    });

    /*
    =========================
    SUBSCRIPTION PRICE
    =========================
    */
    const selectedPlan = document.querySelector(
      ".delivery-frequency option:checked"
    );

    let subscriptionTotal = 0;

    const discountPercentage = selectedPlan
      ? parseFloat(selectedPlan.dataset.discountPercentage || 0)
      : 0;

    document.querySelectorAll(".custom-bundle__option").forEach((option) => {

      const qty = parseInt(
        option.querySelector(".custom-bundle__qty-value")?.value || 0
      );

      const price = parseInt(option.dataset.variantPrice || 0);

      const hasSellingPlan =
        option.dataset.hasSellingPlan === "true";

      if (qty > 0 && !isNaN(price)) {

        let finalPrice = price;

        // Apply discount only to subscription-supported variants
        if (hasSellingPlan && discountPercentage > 0) {
          finalPrice =
            price - (price * discountPercentage / 100);
        }

        subscriptionTotal += finalPrice * qty;
      }
    });

    const subscriptionPriceEl = document.querySelector(".subscription-price");

    if (subscriptionPriceEl) {
      subscriptionPriceEl.innerHTML =
        subscriptionTotal > 0
          ? formatMoney(subscriptionTotal)
          : "";
    }

    /*
    =========================
    MAIN BUNDLE PRICE
    =========================
    */
    const purchaseType = document.querySelector(
      'input[name="purchase_type"]:checked'
    )?.value;

    const bundlePriceEl = document.querySelector(".bundle-price");

    if (bundlePriceEl) {

      // Restore default text if nothing selected
      if (total === 0) {
        bundlePriceEl.innerHTML =
          bundlePriceEl.dataset.defaultText || "";

        return;
      }

      bundlePriceEl.innerHTML = formatMoney(
        purchaseType === "subscription"
          ? subscriptionTotal
          : total
      );
    }
  }

  /*
  =========================
  OPTION SELECTION
  =========================
  */
  const descriptionBox = document.getElementById("custom-bundle-description");
  const descriptionTitle = descriptionBox.querySelector(".custom-bundle__description-title");
  const descriptionText = descriptionBox.querySelector(".custom-bundle__description-text");

  document.querySelectorAll(".custom-bundle__option").forEach((option) => {
    option.addEventListener("click", (e) => {

      if (
        e.target.closest(".custom-bundle__qty-btn") ||
        e.target.closest(".custom-bundle__qty-value")
      ) {
        return;
      }

      const itemsGroup = option.closest(".custom-bundle__items-group");

      itemsGroup.querySelectorAll(".custom-bundle__option").forEach((item) => {
        item.classList.remove("custom-bundle__option--selected");
      });

      option.classList.add("custom-bundle__option--selected");

      updateOptionUI(option);
    });
  });

  /*
  =========================
  HELPERS
  =========================
  */
  function getGroupTotals(group) {
    let total = 0;

    group.querySelectorAll(".custom-bundle__qty-value").forEach((input) => {
      total += parseInt(input.value || 0);
    });

    return total;
  }

  function getLimits(group) {
    return {
      min: parseInt(group.dataset.minQty || 0),
      max: parseInt(group.dataset.maxQty || 999999),
    };
  }

  function showGroupError(group, message = "") {
    const errorBox = group.querySelector(".custom-bundle__error");

    if (!errorBox) return;

    // Clear previous timer
    if (errorBox.hideTimeout) {
      clearTimeout(errorBox.hideTimeout);
    }

    errorBox.textContent = message;
    errorBox.style.display = message ? "block" : "none";

    // Auto hide after 3 sec
    if (message) {
      errorBox.hideTimeout = setTimeout(() => {
        errorBox.textContent = "";
        errorBox.style.display = "none";
      }, 3000);
    }
  }

  function validateBundleGroup(group) {
    const total = getGroupTotals(group);
    const { max } = getLimits(group);

    if (total > max) {
      showGroupError(group, `Maximum ${max} items allowed.`);
      return false;
    }

    showGroupError(group, "");
    return true;
  }

  function updateGroupAvailability(group) {
    const total = getGroupTotals(group);
    const { max } = getLimits(group);

    const reachedMax = total >= max;

    group.querySelectorAll(".custom-bundle__option").forEach((option) => {
      const qty = parseInt(
        option.querySelector(".custom-bundle__qty-value")?.value || 0
      );

      const addBtn = option.querySelector(".custom-bundle__add-btn");
      const plusBtn = option.querySelector(".custom-bundle__qty-btn--plus");
      const minusBtn = option.querySelector(".custom-bundle__qty-btn--minus");

      // ADD BUTTON
      if (addBtn) {
        if (qty > 0) {
          addBtn.disabled = false;
        } else {
          addBtn.disabled = reachedMax;
        }
      }

      // PLUS BUTTON
      if (plusBtn) {
        plusBtn.disabled = reachedMax;
      }

      // MINUS BUTTON
      if (minusBtn) {
        minusBtn.disabled = qty <= 0;
      }
    });
  }

  function updateAddToCartButton() {
    const submitButton = document.querySelector(".custom-bundle__submit");

    if (!submitButton) return;

    let isValid = true;

    document.querySelectorAll(".custom-bundle__items").forEach((group) => {
      const total = getGroupTotals(group);
      const { min } = getLimits(group);

      if (total < min) {
        isValid = false;
      }
    });

    // Always keep the button clickable
    submitButton.disabled = false;

    // Update visual state
    submitButton.classList.toggle(
      "custom-bundle__submit--disabled",
      !isValid
    );

    // Update button text
    const defaultText =
      submitButton.dataset.defaultText || "Add To Cart";

    submitButton.textContent = isValid
      ? defaultText
      : "Add Products to Continue";
  }

  document.querySelectorAll(".custom-bundle__items").forEach((group) => {
    updateGroupAvailability(group);
  });

  /*
  =========================
  ADD BUTTON
  =========================
  */
  document.querySelectorAll(".custom-bundle__add-btn").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const option = button.closest(".custom-bundle__option");
      const grid = option.closest(".custom-bundle__grid");
      const bundleGroup = option.closest(".custom-bundle__items");

      const qtyInput = option.querySelector(".custom-bundle__qty-value");

      const currentQty = parseInt(qtyInput.value || 0);

      const total = getGroupTotals(bundleGroup);

      const { max } = getLimits(bundleGroup);

      // Calculate total after setting this item to 1
      const nextTotal = total - currentQty + 1;

      if (nextTotal > max) {
        showGroupError(bundleGroup, `Maximum ${max} items allowed.`);
        return;
      }

      grid.querySelectorAll(".custom-bundle__option").forEach((item) => {
        item.classList.remove("custom-bundle__option--selected");
      });

      option.classList.add(
        "custom-bundle__option--selected",
        "custom-bundle__option--in-cart"
      );

      qtyInput.value = 1;

      updateOptionUI(option);
      //validateBundleGroup(bundleGroup);
      updateGroupAvailability(bundleGroup);
      updateAddToCartButton();
      updateBundlePrice();
    });
  });

  /*
  =========================
  PLUS
  =========================
  */
  document.querySelectorAll(".custom-bundle__qty-btn--plus").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const option = button.closest(".custom-bundle__option");
      const bundleGroup = option.closest(".custom-bundle__items");

      const qtyInput = option.querySelector(".custom-bundle__qty-value");

      const total = getGroupTotals(bundleGroup);
      const { max } = getLimits(bundleGroup);

      if (total + 1 > max) {
        showGroupError(bundleGroup, `Maximum ${max} items allowed.`);
        return;
      }

      qtyInput.value = parseInt(qtyInput.value) + 1;

      //validateBundleGroup(bundleGroup);
      updateGroupAvailability(bundleGroup);
      updateAddToCartButton();

      updateBundlePrice();
    });
  });

  /*
  =========================
  MINUS
  =========================
  */
  document.querySelectorAll(".custom-bundle__qty-btn--minus").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const option = button.closest(".custom-bundle__option");
      const bundleGroup = option.closest(".custom-bundle__items");

      const qtyInput = option.querySelector(".custom-bundle__qty-value");

      let qty = parseInt(qtyInput.value) - 1;

      if (qty <= 0) {
        qty = 0;

        option.classList.remove("custom-bundle__option--in-cart");
      }

      qtyInput.value = qty;

      //validateBundleGroup(bundleGroup);
      updateGroupAvailability(bundleGroup);
      updateAddToCartButton();

      updateBundlePrice();
    });
  });

  document.querySelector(".delivery-frequency")
    ?.addEventListener("change", updateBundlePrice);

  document.querySelectorAll('input[name="purchase_type"]')
    .forEach((input) => {
      input.addEventListener("change", updateBundlePrice);
    });

  function showBundlePopup(message) {
    const popup = document.getElementById("custom-bundle-popup");

    if (!popup) return;

    popup.textContent = message;
    popup.classList.add("is-visible");

    clearTimeout(popup.hideTimeout);

    popup.hideTimeout = setTimeout(() => {
      popup.classList.remove("is-visible");
    }, 3000);
  }

  /*
  =========================
  ADD BUNDLE TO CART
  =========================
  */
  document.querySelector(".custom-bundle__submit")?.addEventListener("click", async () => {

    let hasError = false;
    const items = [];

    document.querySelectorAll(".custom-bundle__items").forEach((group) => {

      const total = getGroupTotals(group);
      const { min } = getLimits(group);

      // Validate minimum qty only on submit
      if (total < min) {
        hasError = true;
      }

      // Collect variants
      group.querySelectorAll(".custom-bundle__option").forEach((option) => {

        const qty = parseInt(
          option.querySelector(".custom-bundle__qty-value").value || 0
        );

        if (qty > 0) {
          const bundleName =
            document.querySelector(".custom-bundle")?.dataset.bundleName || "";

          const purchaseType = document.querySelector(
            'input[name="purchase_type"]:checked'
          )?.value;

          const selectedSellingPlan = document.querySelector(
            ".delivery-frequency"
          )?.value;

          const hasSellingPlan = option.dataset.hasSellingPlan === "true";

          const item = {
            id: option.dataset.variantId,
            quantity: qty,
            properties: {
              Bundle: bundleName
            }
          };

          if (
            purchaseType === "subscription" &&
            hasSellingPlan &&
            selectedSellingPlan
          ) {
            item.selling_plan = selectedSellingPlan;
          }

          items.push(item);
        }
      });
    });

    // Show popup if bundle is incomplete
    if (hasError) {
      showBundlePopup(
        "Add items to complete your purchase."
      );

      return;
    }

    // Stop if empty
    if (!items.length) return;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add bundle.");
      }

      resetBundleBuilder();

      console.log("Bundle added..");

      window.SLIDECART_UPDATE(window.SLIDECART_OPEN);

    } catch (error) {
      console.error(error);
    }
  });

  function resetBundleBuilder() {

    /*
    =========================
    RESET OPTIONS
    =========================
    */
    document.querySelectorAll(".custom-bundle__option").forEach((option) => {

      option.classList.remove(
        "custom-bundle__option--selected",
        "custom-bundle__option--in-cart"
      );

      const qtyInput = option.querySelector(
        ".custom-bundle__qty-value"
      );

      if (qtyInput) {
        qtyInput.value = 0;
      }
    });

    /*
    =========================
    RESET BUTTONS
    =========================
    */
    document.querySelectorAll(".custom-bundle__items").forEach((group) => {
      updateGroupAvailability(group);
    });

    updateAddToCartButton();

    /*
    =========================
    RESET ERRORS
    =========================
    */
    document.querySelectorAll(".custom-bundle__error").forEach((error) => {
      error.innerHTML = "";
      error.style.display = "none";
    });

    /*
    =========================
    RESET DESCRIPTION
    =========================
    */
    const description = document.querySelector(
      "#custom-bundle-description"
    );

    if (description) {
      description.classList.remove("active");

      const title = description.querySelector(
        ".custom-bundle__description-title"
      );

      const text = description.querySelector(
        ".custom-bundle__description-text"
      );

      if (title) title.innerHTML = "";
      if (text) text.innerHTML = "";

      description.style.borderColor = "";
    }

    /*
    =========================
    RESET IMAGE
    =========================
    */
    // document.querySelector(".bundle-item-image")
    //   ?.classList.add("hide");

    /*
    =========================
    RESET PURCHASE TYPE
    =========================
    */
    const subscriptionInput = document.querySelector(
      'input[name="purchase_type"][value="subscription"]'
    );

    if (subscriptionInput) {
      subscriptionInput.checked = true;
    }

    /*
    =========================
    RESET ACTIVE CARD
    =========================
    */
    document.querySelectorAll(".purchase-card").forEach((card) => {
      card.classList.remove("active");
    });

    subscriptionInput
      ?.closest(".purchase-card")
      ?.classList.add("active");

    /*
    =========================
    RESET PRICE
    =========================
    */
    updateBundlePrice();
  }

});

// Update cart count when slidercart is loaded + updated
const updateCartUI = (cart) => {

  var el = document.querySelector(".count-bubble")
  var cls = 'opacity-0';
  const sc = document.querySelector("#slidecarthq .cart-count");
  if (!el && !sc) return;

  if (cart.item_count > 0) {
    el.classList.remove(cls);
    sc?.setAttribute("data-cart-count", cart.item_count);
  } else {
    el.classList.add(cls);
    sc?.setAttribute("data-cart-count");
  }

  if (el) el.innerText = cart.item_count;
  if (sc) sc.innerText = cart.item_count;
};

window.SLIDECART_LOADED = updateCartUI;
window.SLIDECART_UPDATED = updateCartUI;